import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import navigationService from '../../services/NavigationService';
import { t } from '../../services/i18nService';
import loginService from '../../services/LoginService';
import sessionReader from '../../store/readHelpers/SessionReader';

import styles from './login.scss';

export class Login extends React.PureComponent {
    static propTypes = {
        session: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = { error: false };
    }

    tryLogin() {
        const success = loginService.tryLogin(this.passwordInput.value, this.userIdInput.value);
        if (!success) {
            this.setState({ error: true });
        } else {
            navigationService.navigateToFirstPage();
        }
    }

    onLoginClick = (event) => {
        event.preventDefault();
        this.tryLogin();
        return false;
    };

    onLogoutClick = (event) => {
        event.preventDefault();
        loginService.logout();
        return false;
    };

    render() {
        const candidateId = sessionReader.getCandidateId(this.props.session);
        const isLoggedIn = sessionReader.isLoggedIn(this.props.session);
        return (
            <div className={styles.loginContainer} style={{ backgroundImage: 'url(lib/player/images/student-bg.jpg)' }}>
                <div className={styles.loginBox}>
                    <div className={styles.logo} style={{ backgroundImage: 'url(lib/player/images/logo/inspera.png)' }} />
                    {isLoggedIn ?
                        (
                            <div className={styles.offlineLogin} id="logoutFormContainer">
                                <h2>{t('login.youAreLoggedInAs', { candidateId })}</h2>
                                <button
                                    className={`${styles.offlineLoginBtn} btn btn-highlight`}
                                    href="javascript:void(0)"
                                    onClick={navigationService.navigateToFirstPage}
                                >
                                    {t('login.continueToTest')}
                                </button>
                                <p>
                                    {t('login.doYouWishToLogOut')}
                                    &nbsp;
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a href="#" onClick={this.onLogoutClick}>{t('general.clickHere')}</a>.
                                </p>
                            </div>
                        )
                        :
                        (
                            <div className={styles.offlineLogin} id="loginFormContainer">
                                <form>
                                    <h2>{t('login.loginHeader')}</h2>
                                    <label htmlFor="loginInputUserId">{t('login.userIdInputLabel')}</label>
                                    <input
                                        className={styles.inputField}
                                        id="loginInputUserId"
                                        ref={(element) => { this.userIdInput = element; }}
                                        type="text"
                                    />

                                    <label htmlFor="loginInputPassword">{t('login.passwordInputLabel')}</label>
                                    <input
                                        className={styles.inputField}
                                        id="loginInputPassword"
                                        ref={(element) => { this.passwordInput = element; }}
                                        type="password"
                                    />

                                    {
                                        this.state.error ?
                                            <div
                                                className={styles.loginError}
                                                id="loginErrorMsg"
                                            >{t('login.loginFailedMessage')}</div>
                                            : null
                                    }
                                    <div className={styles.loginBtn}>
                                        <button className="btn btn--highlight" onClick={this.onLoginClick}>
                                            {t('login.loginButtonText')}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        )
                    }

                    <span className={styles.credits}>
                        Photo by Dominik Kollau
                    </span>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        session: state.session,
    };
}

const LoginContainer = connect(mapStateToProps)(Login);
export default LoginContainer;
